module.exports = __webpack_public_path__ + "images/Layout.1263c0eb63796ed2c0121975924732a9.svg";